const tabs = [
  "Overview",
  "Members",
  "Workspaces",
];

const DrawerNavigation = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="border-b border-slate-200 bg-white px-6">

      <div className="flex gap-8">

        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() =>
              setActiveTab(tab)
            }
            className={`relative py-4 text-sm font-semibold transition-colors ${
              activeTab === tab
                ? "text-blue-600"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            {tab}

            {activeTab === tab && (
              <span className="absolute bottom-0 left-0 h-[2px] w-full rounded-full bg-blue-600" />
            )}
          </button>
        ))}

      </div>

    </div>
  );
};

export default DrawerNavigation;